import { BurnResponse } from "@/types/ticket/ticketValidation";

export async function burnTicketService(uuid: string): Promise<BurnResponse> {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/tickets/burn/${uuid}`, {
        method: 'GET',
        credentials: 'include'
    });
    if (response.status === 401) {
        throw new Error('Please log in to your organization to burn this ticket.');
    }
    if (response.status === 403) {
        const errorData = await response.json();
        if (errorData.accessDenied) {
            throw new Error('You do not have access to this ticket. Please log in to the correct organization.');
        }
        throw new Error('Access denied.');
    }
    if (!response.ok) {
        throw new Error('Failed to burn the ticket.');
    }
    return response.json();
}